import axios from 'axios';
import authConfig from "src/configs/auth"
import { toast } from "react-hot-toast"
import { PublicRoutes } from 'src/utils/constants';

const targetKeys = ['business_name', 'first_name', 'businessName', 'firstName'];

const isPlainObject = (obj) => {
    if (typeof obj !== 'object' || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    return proto === null || proto === Object.prototype;
};

const sanitizeFields = (obj) => {
    if (obj === null || obj === undefined) {
        return obj;
    }

    // Handle FormData safely
    if (typeof FormData !== 'undefined' && obj instanceof FormData) {
        const newFormData = new FormData();
        for (const [key, value] of obj.entries()) {
            if (typeof value === 'string' && targetKeys.includes(key)) {
                newFormData.append(key, value.trim());
            } else {
                newFormData.append(key, value);
            }
        }
        return newFormData;
    }

    if (Array.isArray(obj)) {
        return obj.map(sanitizeFields);
    }

    if (isPlainObject(obj)) {
        const sanitized = {};
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                let value = obj[key];
                if (typeof value === 'string' && targetKeys.includes(key)) {
                    value = value.trim();
                } else if (isPlainObject(value) || Array.isArray(value)) {
                    value = sanitizeFields(value);
                }
                sanitized[key] = value;
            }
        }
        return sanitized;
    }

    return obj;
};


export const axiosInstance = axios.create({
    headers: {
        "Content-Type": "application/json",
        "authorization": `Bearer ${localStorage.getItem(authConfig.storageTokenKeyName)}`,
    },
});

// You can set default headers like Content-Type here
axiosInstance.defaults.headers.common['Content-Type'] = 'application/json';

// Add a request interceptor to set the authorization header and sanitize payloads
axiosInstance.interceptors.request.use(
    (config) => {
        // Get the token from localStorage and set the authorization header
        const token = window.localStorage.getItem(authConfig.storageTokenKeyName);
        if (token) {
            config.headers['authorization'] = `Bearer ${token}`;
        }
        
        // Trim and sanitize targeted fields before sending the API request
        if (config.data) {
            config.data = sanitizeFields(config.data);
        }
        if (config.params) {
            config.params = sanitizeFields(config.params);
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add an interceptor to handle 401 responses and sanitize incoming response data
axiosInstance.interceptors.response.use(
    response => {
        // Trim and sanitize targeted fields returned in the API response
        if (response.data) {
            response.data = sanitizeFields(response.data);
        }
        return response;
    },
    error => {
        if (error.response && error.response.status === 401) {
            // Handle the 401 response here, e.g., by redirecting to a login page
            // You can also clear the token from localStorage if needed
            window.localStorage.removeItem(authConfig.storageUserDataKeyName);
            window.localStorage.removeItem(authConfig.storageTokenKeyName);
            if (!PublicRoutes.includes(window.location.pathname)) {
                toast.error('Session expired. Please log in again.');
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

// access token ->  8hr
// refresh token -> 90 days

